<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Loader :loading="httpSend">
      <div v-if="entidade" class="row">
        <div class="col-lg-12">
          <div v-if="duam.dam_codigo" class="card">
            <div class="card-body">
              <div class="invoice-title mb-4">
                <h4 class="float-left font-size-16">DUAM {{ duam.dam_codigo }}</h4>
              </div>
              <hr/>
              <div class="pl-2 mt-3">
                <h3 class="font-size-16">Resumo</h3>
              </div>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>Vencimento Original</th>
                    <th class="text-right">{{ duam.dam_data_venc_orig | formatDate }}</th>
                  </tr>
                  <tr>
                    <th>Tributo</th>
                    <th class="text-right">Valor</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="t in tributos" :key="t.trb_codigo">
                    <td>{{ t.trb_nome }}</td>
                    <td class="text-right">{{ t.dut_valortotal | formatNumeroBr }}</td>
                  </tr>
                  <tr>
                    <td colspan="1" class="text-right">Subtotal</td>
                    <td class="text-right">{{ duam.dut_valortributo | formatNumeroBr }}</td>
                  </tr>
                  <tr>
                    <td colspan="1" class="border-0 text-right">
                      <strong>Atualização (+)</strong>
                    </td>
                    <td class="border-0 text-right">{{ duam.dut_atualizacao | formatNumeroBr }}</td>
                  </tr>
                  <tr>
                    <td colspan="1" class="border-0 text-right">
                      <strong>Juros (+)</strong>
                    </td>
                    <td class="border-0 text-right">{{ duam.dut_juros | formatNumeroBr }}</td>
                  </tr>
                  <tr>
                    <td colspan="1" class="border-0 text-right">
                      <strong>Multa (+)</strong>
                    </td>
                    <td class="border-0 text-right">{{ duam.dut_multa | formatNumeroBr }}</td>
                  </tr>
                  <tr>
                    <td colspan="1" class="border-0 text-right">
                      <strong>Desconto (-)</strong>
                    </td>
                    <td class="border-0 text-right">{{ duam.dut_desconto | formatNumeroBr }}</td>
                  </tr>
                  <tr>
                    <td colspan="1" class="text-right">
                      <h4 class="m-0">Total</h4>
                    </td>
                    <td class="border-0 text-right">
                      <h4 class="m-0 text-danger font-weight-bold">{{ duam.dut_valortotal | formatNumeroBr }}</h4>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="row">
                <div class="col-sm-6 text-left">
                  <button type="button" title="Baixar Duam" @click="visualiza_boleto()"
                          class="btn btn-label mr-2 mb-2 btn-primary"><i
                      class="bx bx-download label-icon"></i>  Baixar Duam
                  </button>
                </div>
                <div class="col-sm-6 text-right">
                  <address>
                    <h6>Vencimento</h6>
                    <h4 class="m-0 font-weight-bold">{{ duam.dam_data_venc_atu | formatDate }}</h4>
                  </address>
                </div>
              </div>
              <div v-if="entidade.par_chave_pix || entidade.par_tipo_cobranca === '2'">
              <div class="text-center mb-3">
                <h4 class="m-0">Forma de Pagamento</h4>
              </div>
              <div class="row">
                <div v-if="entidade.par_chave_pix" class="col-xl-4 col-sm-4">
                  <label v-show="entidade.par_chave_pix" class="card-radio-label mb-3">
                    <input
                        type="radio"
                        name="pay-pix"
                        v-model="pagamento.forma"
                        id="pay-pix"
                        class="card-radio-input"
                        value="pix"/>
                    <div class="card-radio">
                      <i class="mdi mdi-qrcode-scan font-size-24 align-middle mr-2"></i>
                      <span class="font-size-16">Pix</span>
                    </div>
                  </label>
                  <span v-show="entidade.par_chave_pix" class="text-dark">Baixa <b>imediata</b> após o pagamento via Pix.</span>
                </div>
                <div class="col-xl-4 col-sm-4">
                </div>
                <div v-if="entidade.par_tipo_cobranca === '2'" class="col-xl-4 col-sm-4">
                  <label class="card-radio-label mb-3">
                    <input
                        type="radio"
                        name="pay-boleto"
                        id="pay-boleto"
                        v-bind:disabled="entidade.par_tipo_cobranca !== '2'"
                        v-model="pagamento.forma"
                        value="boleto"
                        class="card-radio-input"/>
                    <div class="card-radio">
                      <i class="mdi mdi-barcode font-size-24 align-middle mr-2"></i>
                      <span v-show="entidade.par_tipo_cobranca === '1'" class="font-size-16">DUAM de Arrecadação</span>
                      <span v-show="entidade.par_tipo_cobranca === '2'" class="font-size-16">Boleto Bancário</span>
                    </div>
                  </label>
                  <span class="text-dark">Baixa em até <b>3 dias úteis</b> após o pagamento do boleto.</span>
                </div>
              </div>
              <div class="d-print-none">
                <div class="text-center">
                  <button type="button" title="Realizar Pagamento" @click="registrar()"
                          class="btn btn-label mr-2 mb-2 btn-success"><i
                      class="bx bx-money label-icon"></i>  Realizar Pagamento
                  </button>
                </div>
              </div>
              </div>
              <div v-if="erros.status && erros.tipo === 1" class="row mt-3">
                <div class="col-sm-6">
                  <b-card header-class="bg-transparent border-danger" class="border border-danger">
                    <template v-slot:header>
                      <h5 class="my-0 text-danger">
                        <i class="mdi mdi-block-helper mr-3"></i>{{ erros.titulo }}
                      </h5>
                    </template>
                    <h5 class="card-title mt-0">Detalhe do erro</h5>
                    <p class="card-text">{{ erros.mensagem }}</p>
                    <p class="card-text">
                      {{ erros.detalhe }}
                    </p>
                    <p class="card-text">
                      <b>Entre em contato com a entidade</b>
                    </p>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row mt-3">
            <div class="col-sm-12">
              <b-card header-class="bg-transparent border-primary" class="border border-primary">
                <h5 class="my-0 text-primary">
                  <i class="bx bx-x mr-3"></i>DUAM Indisponível para Pagamento
                </h5>
              </b-card>
            </div>
          </div>
        </div>
      </div>
      <div v-if="entidade" class="row">
        <div class="col-sm-6">
          <div v-if="pix.pix_qr_code" class="card">
            <div class="card-body">
              <h4 class="card-title">Pagamento via Pix</h4>
              <ol>
                <li>
                  Acesse o aplicativo da sua instituição financeira;
                </li>
                <li>
                  Dentro da opção “Pix”, toque em Pagar com QR Code;
                </li>
                <li>
                  Posicione o aparelho para leitura do QR Code;
                </li>
                <li>
                  Confirme os dados e faça o pagamento;
                </li>
                <li>
                  Após realizar o pagamento clique no botão <b>Verificar Pagamento</b>.
                </li>
              </ol>
              <div class="text-center">
                <vue-qrcode :margin="1" :value="pix.pix_qr_code"/>
              </div>
              <div class="text-center mt-3">
                <span style="font-size: 12px" class="mr-3">Pix Copia e Cola</span>
              </div>
              <div class="text-center">
                <textarea class="form-control mt-2" rows="2" style="resize: none" type="text"
                          v-bind:value="pix.pix_qr_code"></textarea>
              </div>
              <div class="text-center mt-3">
                <button type="button" title="Baixar Duam Pix" @click="visualiza_boleto()"
                        class="btn btn-label mr-2 mb-2 btn-primary"><i
                    class="bx bx-download label-icon"></i>  Baixar Duam Pix
                </button>
                <button type="button" title="Verificar Pagamento" @click="verificaPagamento()"
                        class="btn btn-label mr-2 mb-2 btn-success"><i
                    class="bx bx-check label-icon"></i>  Verificar Pagamento
                </button>
              </div>
              <div v-if="erros.status && erros.tipo === 2" class="row mt-3">
                <div class="col-sm-12">
                  <b-card header-class="bg-transparent border-danger" class="border border-danger">
                    <template v-slot:header>
                      <h5 class="my-0 text-danger">
                        <i class="mdi mdi-block-helper mr-3"></i>{{ erros.titulo }}
                      </h5>
                    </template>
                    <h5 class="card-title mt-0">Detalhe do erro</h5>
                    <p class="card-text">{{ erros.mensagem }}</p>
                    <p class="card-text">
                      {{ erros.detalhe }}
                    </p>
                    <p class="card-text">
                      <b>Entre em contato com a entidade</b>
                    </p>
                  </b-card>
                </div>
              </div>
              <div class="col-sm-12 mt-3">
                <b-card v-if="pix.pago === true" header-class="bg-transparent border-success"
                        class="border border-success">
                  <template v-slot:header>
                    <h5 class="my-0 text-success">
                      <i class="mdi mdi-check-all mr-3"></i>Pagamento Confirmado
                    </h5>
                  </template>
                  <p class="card-text">
                    Data do pagamento: {{ pix.info_pagamento.data_credito | formatDate }}<br>
                    Valor Pago: {{ pix.info_pagamento.valor_pago | formatNumeroBr }}<br>
                    Pagador:<br>
                    <span class="ml-3">Nome: {{ pix.info_pagamento.pagador.nome }}</span><br>
                    <span class="ml-3"
                          v-show="pix.info_pagamento.pagador.cpf">CPF: {{ pix.info_pagamento.pagador.cpf }}</span>
                    <span class="ml-3"
                          v-show="pix.info_pagamento.pagador.cnpj">CNPJ: {{ pix.info_pagamento.pagador.cnpj }}</span>
                  </p>
                  <div v-if="not_hash" class="text-center mt-3">
                    <button type="button" @click="visualiza_nota(not_hash)" class="btn btn-info">
                      Clique aqui para emitir Nota Fiscal Avulsa
                    </button>
                  </div>
                </b-card>
                <b-card v-if="pix.pago === false" header-class="bg-transparent border-danger"
                        class="border border-danger">
                  <template v-slot:header>
                    <h5 class="my-0 text-danger">
                      <i class="mdi mdi-block-helper mr-3"></i>Pagamento ainda não foi confirmado
                    </h5>
                  </template>
                  <p class="card-text">
                    Aguarde alguns minutos e faça a verificação de pagamento novamente.
                  </p>
                </b-card>
              </div>
            </div>
          </div>
        </div>
        <div v-if="boleto.status" class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Pagamento via Boleto Bancário</h4>
              <p class="card-title-desc">
                O pagamento pode ser realizado pelo seu banco ou em agência parceira (como uma casa lotérica ou
                supermercado) e ainda das seguintes formas:
              </p>
              <ol>
                <li>
                  Nos terminais de autoatendimento,
                </li>
                <li>
                  Online, via Internet Banking;
                </li>
                <li>
                  Pelo telefone;
                </li>
                <li>
                  No caixa eletrônico;
                </li>
                <li>
                  Via aplicativo da sua instituição financeira.
                </li>
              </ol>
              <p>
                O pagamento por boleto tem um prazo de compensação de até <b>72 horas úteis</b>, isto é, de <b>3
                dias</b>.
              </p>
              <div class="text-center mb-3">
                <span style="font-size: 12px" class="mr-3">Código de Barras</span>
                <button v-show="false" type="button" id="copy_codigo_barra"
                        @click="copy_codigo_barra(boleto.bol_linha_digitavel)" class="btn btn-sm btn-secondary"><i
                    class="mdi mdi-content-copy"></i>
                  Copiar
                </button>
                <textarea class="form-control mt-2" rows="2" style="resize: none" type="text"
                          v-bind:value="boleto.bol_linha_digitavel"></textarea>
              </div>
              <div class="text-center">
                <button type="button" title="Baixar Boleto" @click="visualiza_boleto()"
                        class="btn btn-label mr-2 mb-2 btn-primary"><i
                    class="bx bx-download label-icon"></i>  Baixar Boleto
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="entidade.par_tipo_cobranca === '1'" class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Pagamento via DUAM de Arrecadação</h4>
              <p class="card-title-desc">
                O pagamento pode ser realizado pelo seu banco ou em agência parceira (como uma casa lotérica ou
                supermercado) e ainda das seguintes formas:
              </p>
              <ol>
                <li>
                  Nos terminais de autoatendimento,
                </li>
                <li>
                  Online, via Internet Banking;
                </li>
                <li>
                  Pelo telefone;
                </li>
                <li>
                  No caixa eletrônico;
                </li>
                <li>
                  Via aplicativo da sua instituição financeira.
                </li>
              </ol>
              <p>
                O pagamento por DUAM de Arrecadação tem um prazo de compensação de até <b>72 horas úteis</b>, isto é, de <b>3
                dias úteis</b>.
              </p>
              <div class="text-center">
                <button type="button" title="Baixar DUAM de Arrecadação" @click="visualiza_boleto()"
                        class="btn btn-label mr-2 mb-2 btn-primary"><i
                    class="bx bx-download label-icon"></i> Baixar DUAM de Arrecadação
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
    <Aguarde :show="showAguarde"></Aguarde>
  </Layout>
</template>

<script>
import VueQrcode from "vue-qrcode";
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {guiaPagamento} from "@/api/financeiro/guia";
import {registerPagamento} from "@/api/financeiro/pagamento";
import {copy, isMobile} from "@/helps/util";
import {impressao} from "@/helps/impressao";
import {setRelNotaFiscal} from "@/api/relatorio/nota_fiscal";
import Swal from "sweetalert2";
import {getFinanceiroGuia} from "@/api/relatorio/financeiro";
import {verificaRetornoPagamentoPix} from "@/api/admin/gestao/retorno_pagamento";

const {notifyErro, notifySucesso} = require("../../../../helps/notificacao");

export default {
  page: {
    title: "Pagamento de DUAM",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Aguarde,
    VueQrcode
  },
  created() {
    this.getGuia();
  },
  data() {
    return {
      size: 300,
      title: "Pagamento",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAMs',
          href: '/contribuinte/financeiro/guia',
        },
        {
          text: 'Pagamento',
          active: true,
        },
      ],
      par_chave_pix: null,
      not_hash: false,
      httpSend: false,
      showAguarde: false,
      entidade:null,
      duam: {
        dam_codigo: null
      },
      tributos: [],
      pagamento: {
        forma: 'pix',
        registrado: false
      },
      erros: {
        tipo: 1,
        status: false,
        titulo: '',
        mensagem: '',
        detalhe: null,
      },
      pix: {
        pix_qr_code: null,
        status: null,
        pix_hash: null,
        qr_code: '',
        pago: -1,
        info_pagamento: null,
      },
      boleto: {
        status: null,
        bol_hash: null,
        bol_linha_digitavel: null
      },
    };
  },
  methods: {
    p_init() {
      if (!this.entidade.par_chave_pix) {
        this.pagamento.forma = 'boleto';
      }
    },
    resetErros() {
      this.erros = {
        tipo: 1,
        titulo: '',
        status: false,
        mensagem: '',
        detalhe: null,
      }
    },
    exibirPix(dados) {
      this.pix = dados;
      if (dados.qr_code) {
        this.pix.pix_qr_code = dados.qr_code;
      }
    },
    exibirBoleto(dados) {
      this.boleto.status = true;
      this.boleto.bol_hash = dados.bol_hash;
      this.boleto.bol_linha_digitavel = dados.bol_linha_digitavel;
    },
    getGuia() {
      this.httpSend = true;
      guiaPagamento(this.$route.params.dam_hash).then(response => {
        if (response.status) {
          const dados = response.dados
          this.entidade = dados.entidade;
          this.tributos = dados.tributos;
          if (dados.guia) {
            if (dados.guia.dam_codigo) {
              this.duam = dados.guia;
            }
          }
          if (dados.pix) {
            if (dados.pix.pix_hash) {
              this.exibirPix(dados.pix);
            }
          }
          if (dados.boleto) {
            if (dados.boleto.bol_hash) {
              this.exibirBoleto(dados.boleto)
            }
          }
          this.p_init();
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    registrar() {
      if (this.pagamento.forma === 'pix' && this.pix.pix_qr_code) {
        Swal.fire({
          title: "Pix já está disponível",
          text: "O Pix para pagamento já está disponível",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#100e0e",
          confirmButtonText: "Entendi",
        });
        return;
      }
      if (this.pagamento.forma === 'boleto' && this.boleto.bol_hash) {
        Swal.fire({
          title: "Boleto já está disponível",
          text: "O boleto para pagamento já está disponível",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#100e0e",
          confirmButtonText: "Entendi",
        });
        return;
      }
      this.resetErros();
      this.showAguarde = true;
      registerPagamento({
        dam_hash: this.duam.dam_hash,
        forma: this.pagamento.forma
      }).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          if (this.pagamento.forma === 'pix') {
            this.exibirPix(response.dados.data);
          } else {
            this.exibirBoleto(response.dados)
          }
        } else {
          const erro = response.dados;
          notifyErro("DattaNFSe", response.mensagem)
          this.erros.titulo = response.mensagem;
          this.erros.status = true;
          this.erros.mensagem = erro.mensagem;
          this.erros.detalhe = erro.info_erro;
        }
      }).catch(error => {
        notifyErro("DattaNFSe", error)
      }).finally(() => {
        this.showAguarde = false
      })
    },
    verificaPagamento() {
      this.resetErros();
      this.pix.pago = -1;
      this.showAguarde = true;
      verificaRetornoPagamentoPix(this.pix.pix_hash).then(response => {
        if (response.status) {
          const data = response.dados;
          this.pix.pago = data.liquidado;
          this.pix.info_pagamento = data;
        } else {
          const erro = response.dados;
          notifyErro("DattaNFSe", response.mensagem)
          this.erros.tipo = 2
          this.erros.titulo = response.mensagem;
          this.erros.status = true;
          this.erros.mensagem = erro.mensagem;
          this.erros.detalhe = erro.info_erro;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    visualiza_nota(not_hash) {
      this.httpSend = true;
      if (isMobile()) {
        impressao(setRelNotaFiscal(not_hash), 'P').catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSend = false;
        })
      } else {
        this.$router.push({name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: not_hash}})
      }
    },
    visualiza_boleto() {
      this.httpSend = true;
      impressao(getFinanceiroGuia(this.duam.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    copy_codigo_barra(value) {
      copy(value)
    },
  }
};
</script>
<style lang="css">
.card-radio-input:checked + .card-radio {
  border-color: #34c38f !important;
}
</style>


